import { atom } from "jotai";
import { reconnectEdge } from "@xyflow/react";
import { edgesAtom } from "./edgesAtom";
import { saveCanvasSetter } from "../persistence";

export const updateEdgeConnectionSetter = atom(
  null,
  (get, set, { oldEdge, newConnection }) => {
    const edges = get(edgesAtom);
    const updatedEdges = reconnectEdge(oldEdge, newConnection, edges);
    set(edgesAtom, updatedEdges);

    set(saveCanvasSetter, {
      edges: updatedEdges,
    });
  },
);

updateEdgeConnectionSetter.debugLabel = "updateEdgeConnectionSetter";
